import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import SharedLinkPage from './components/SharedLinkPage';
import { msalConfig } from './msalConfig';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Wait for MSAL to initialize (and finish redirect login) before rendering
msalInstance.initialize().then(() =>
  msalInstance.handleRedirectPromise().catch((err) => {
    console.error('MSAL redirect failed:', err);
  })
).then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <MsalProvider instance={msalInstance}>

      {/* The Router must wrap all Routes */}
      <Router>
        <Routes>
          {/* Shared link route with path /shared-links/:token */}
          <Route path="/shared-links/:token" element={<SharedLinkPage />} />

          {/* Legacy share route /shared/:token */}
          <Route path="/shared/:token" element={<SharedLinkPage />} />

          {/* Main app route (catch-all) */}
          <Route path="/*" element={<App />} />
        </Routes>
      </Router>

    </MsalProvider>
  );
});

reportWebVitals();
